class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle || this.dataset.drawerInitialized) return;

    this.dataset.drawerInitialized = 'true';
    this.addEventListener('click', this.onClick);
    this.mainDetailsToggle.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick);
    });
  }

  bindEvents() {
    this.connectedCallback();
  }

  onClick(event) {
    if (!event.target.closest('.mobile-facets__close-drawer')) return;

    event.preventDefault();
    event.stopPropagation();
    this.closeMainDrawer();
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      detailsElement.classList.toggle('menu-opening');
      document.body.classList.toggle('overflow-hidden', !isOpen);
    }
  }

  closeMainDrawer() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('menu-drawer', MenuDrawer);
